import {AcitivityList} from "./AcitivityList";
import {AcitivityEdit} from "./AcitivityEdit";
import {AcitivityCreate} from "./AcitivityCreate";

export default {
    list: AcitivityList,
    create: AcitivityCreate,
    edit: AcitivityEdit
};
